import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/atoms/Tabs';
import { useLog } from '@/hooks/V3/useLog';
import { useAppSelector } from '@/redux/store';
import { deviceUuidState } from '@/store/atom';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { DashboardCard } from '../card';
import ChangeNameDashboard from './ChangeNameDashboard';
import ChatBotDashboard from './ChatBotDashboard';
import MakeNameDashboard from './MakeNameDashboard';

const tabKeys = ['aiChatBot', 'makeName', 'changeName'] as const;
type TabKey = (typeof tabKeys)[number];

const SellerboxAi = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('makeName');

  const { UserNo } = useAppSelector((state) => state.user);
  const { setUserEventHistory } = useLog(UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);

  const handleTabChange = (val: string) => {
    const newTab = val as TabKey;
    setActiveTab(newTab);

    // 탭 전환 로그 이벤트
    setUserEventHistory({
      eventName: 'ai_tab_change_web_dashboard',
      eventValue: newTab,
      deviceUuid,
    });
  };

  return (
    <DashboardCard>
      <div className="text-gr-900 Body1S16">Sellerbox AI</div>
      <Tabs
        defaultValue="makeName"
        value={activeTab}
        onValueChange={handleTabChange}
        className="w-full space-y-5"
      >
        <TabsList className=" w-fit">
          {/* TODO: 추후 주석 해제 */}
          {/* <TabsTrigger value="aiChatBot">셀러박스 AI 챗봇</TabsTrigger> */}
          <TabsTrigger value="makeName">상품명 제작</TabsTrigger>
          <TabsTrigger value="changeName">도매몰 상품명 변경</TabsTrigger>
        </TabsList>
        {/* TODO: 추후 주석 해제 */}
        {/* {activeTab === 'aiChatBot' && (
          <TabsContent value="aiChatBot" forceMount>
            <ChatBotDashboard activeTab={activeTab} />
          </TabsContent>
        )} */}
        {activeTab === 'makeName' && (
          <TabsContent value="makeName" forceMount>
            <MakeNameDashboard activeTab={activeTab} />
          </TabsContent>
        )}
        {activeTab === 'changeName' && (
          <TabsContent value="changeName" forceMount>
            <ChangeNameDashboard activeTab={activeTab} />
          </TabsContent>
        )}
      </Tabs>
    </DashboardCard>
  );
};

export default SellerboxAi;
